import React, { Suspense } from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "../../layouts/Layout";
import ProtectedRoute from "../Routes/ProtectedRoute";

import PageLoader from "../../components/ui/pageLoader/PageLoader";
import ForgotPassword from "../../pages/forgotPassword/ForgotPassword";
import ResetPassword from "../../pages/resetPassword/ResetPassword";
import TwoFactorAuthentication from "../../pages/twoFectorAuthentication/TwoFactorAuthentication";
import UnderConstruction from "../../components/ui/underConstruction/UnderConstruction";


const Login = React.lazy(() => import("../../pages/login/Login"));
const NotFound = React.lazy(() => import("../../pages/notFound/NotFound"));

const AppRoutes = (props) => {

  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route name="Layout" path="/"
            element={
              <ProtectedRoute>
              <Layout componentRoutes={props.componentRoutes} />
            </ProtectedRoute>
            }
          >
            {props.componentRoutes.map((route) => (
              // !hasPermission(route.securityKey)?.noPermission && (
              <Route
                key={route.path}
                path={route.path}
                name={"test"}
                element={< route.component securityKey={route.securityKey} />}
              />
              // )
            ))}

            {/* ------------- Child Routes --------------- */}
            {props.componentRoutes.map((route) => (
              route?.children?.map((childRoute) => (
                <Route
                  key={childRoute.path}
                  path={childRoute.path}
                  element={<childRoute.component securityKey={childRoute.securityKey} />}
                />
              ))
            ))}

          </Route>

          <Route exact name="Login" path="/Login" element={<Login />} />
          {/* <Route exact name="TwoFactorAuthentication" path="/TwoFactorAuthentication" element={<TwoFactorAuthentication />} /> */}
          <Route exact name="ResetPassword" path="/resetPassword" element={<ResetPassword />} />
          <Route exact name="ForgotPassword" path="/forgotPassword" element={<ForgotPassword />} />
          <Route exact name="TwoFactorAuthentication" path="/TwoFactorAuthentication" element={<TwoFactorAuthentication />} />
          
          <Route path="*" element={<NotFound />} />
        

        </Routes>
      </Suspense>
    </Router>
  );
};

AppRoutes.propTypes = {
  componentRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      component: PropTypes.elementType.isRequired,
      securityKey: PropTypes.string.isRequired,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          path: PropTypes.string.isRequired,
          component: PropTypes.elementType.isRequired,
          securityKey: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
};

export default AppRoutes;
